import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HTTPError } from 'ky';

import './styles.css';
import { routeTree } from './routeTree.gen';
import { applyTheme, loadSavedTheme } from './themes/themes';

const savedTheme = loadSavedTheme();
if (savedTheme) applyTheme(savedTheme);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // Disable retry on 401 — global error boundary handles full-page reload to re-trigger CF flow.
        if (error instanceof HTTPError && error.response.status === 401) return false;
        return failureCount < 2;
      },
      staleTime: 30_000,
    },
  },
});

const router = createRouter({
  routeTree,
  context: { queryClient },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
